// extracted by mini-css-extract-plugin
export default {"details_description_title":"style_details_description_title__rjU7b"};